import { PERMISSIONS } from '../../core/utils/permissions';
import { queryKeys } from '../../core/api/queryKeys';

export const USER_PERMISSIONS = {
  READ: PERMISSIONS.USERS_READ,
  WRITE: PERMISSIONS.USERS_WRITE,
};

export const USER_QUERY_KEYS = queryKeys.users;
